import { render, staticRenderFns } from "./SkillsForPeople.vue?vue&type=template&id=657702d4"
import script from "./SkillsForPeople.vue?vue&type=script&lang=js"
export * from "./SkillsForPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports